import { Spin } from 'antd'
import { Suspense, lazy } from 'react'
import lang from './utils/intl/language'

const Loading = () => <Spin size='large' style={{ position: 'absolute', top: '50%', left: '50%' }} />

const LoadMain = () =>
  import('@/components/Navigation/Main').catch(() => {
    //if this fails, that means the main chunk hash is probably stale cached so we'll force reload
    window.location.reload()
    return { default: Loading }
  })

//this is to lazily load the main app after the intl language file has loaded.
//if we don't do this, the app will call the t() function before the locale has loaded from the server,
//causing missing translation keys on first load.
const Main = lazy(() => lang.then(() => LoadMain()))

export const Bootstrapper = () => (
  <Suspense fallback={<Loading />}>
    <Main />
  </Suspense>
)
